import React, { Component } from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import RegistrationForm from "./RegistrationForm";
import RegistrationOtp from "./RegistrationOtp";
import LoginDesc from "./LoginDesc";
import { PATHS } from "../../constant";
import RegisterDesc from "./RegisterDesc";

export class Registration extends Component {
  state = {
    show: false,
    data: {},
    mobileNumber: "",
    email: ""
  };

  handleClose = () => {
    this.setState({ show: false });
  };

  handleCrossBtn = () => {
    // const { history } = this.props;
    this.setState({ show: false });
    // history.push(PATHS.LOGIN);
  };

  handleShow = data => {
    this.setState({
      show: true,
      data: data
    });
  };

  changePhone = value => {
    this.setState({ mobileNumber: value });
  };

  changeEmail = value => {
    this.setState({ email: value });
  };

  render() {
    const { history } = this.props;
    const { show, data, mobileNumber, email } = this.state;
    return (
      <React.Fragment>
        <div className="signup user-register">
          <RegistrationOtp
            show={show}
            handleClose={this.handleClose}
            handleCrossBtn={this.handleCrossBtn}
            changePhone={this.changePhone}
            changeEmail={this.changeEmail}
            data={data}
          />
          <div className="register-outer">
            <div className="login-register-tabs">
              <button
                className="login-btn"
                onClick={() => history.push(PATHS.LOGIN)}
              >
                Login
              </button>
              <button className="register-btn active">Register</button>
            </div>

            <RegistrationForm
              email={email}
              mobileNumber={mobileNumber}
              handleShow={this.handleShow}
            />
          </div>
          <div className="no-account">
            <LoginDesc
              accountHeading="Have an account?"
              subHeading="Login Now"
              buttonText="Login"
              buttonLink="/login"
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

Registration.propTypes = {
  history: PropTypes.shape({})
};

Registration.defaultProps = {
  history: {}
};

export default withRouter(Registration);
